import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { authLog } from 'src/app/auth/auth.handler';
import { Auth } from 'src/app/core/common/auth';
import { UI } from 'src/app/core/helpers/ui';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const auth = inject(Auth);
  const router = inject(Router);
  const ui = inject(UI);
  authLog(`auth.flow::=>auth.guard: canActivate`, { currentUrl: router.url, nextUrl: state.url });
  return auth.isAuthenticated$.pipe(
    first(),
    switchMap(authenticated => {
      authLog(`auth.flow::=>auth.guard:`, { authenticated, currentUrl: router.url, nextUrl: state.url });
      if (authenticated) {
        return of(true);
      }

      ui.showLoading();
      return auth
        .login(`${window.origin}${state.url}`) // the return url needed on the web version
        .pipe(
          map(result => {
            if (result?.isAuthenticated) {
              authLog(`auth.flow::=>auth.guard: logged-in successfully, navigating to:`, { url: state.url });
              return true;
              /* no longer needed to navigate after authentication
                  on web the guard won't reach the map operator because the page will get redirected to the auth server
                  on native if the login was successful the guard will resolve to true and angular will allow accessing the page */
            } else {
              authLog(`auth.flow::=>auth.guard: login failed, redirecting to home page`, { errorMessage: result?.errorMessage });
              // this.router.navigate(['/tabs/home']); Do not call router.navigate… inside a guard
              return router.createUrlTree(['/tabs/home']);
            }
          })
        );
    })
  );
};
